import {ContentType} from 'mw/api/Metadata';
import {PlayerType} from 'mw/playback/types/PlayerType';

import {PlaybackController} from './PlaybackController';

export class AudioPlayer extends PlaybackController {

  public constructor(playerType: PlayerType) {
    super(playerType, ContentType.AUDIO);
  }
}
